import React, {Fragment} from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableContainer from '@mui/material/TableContainer';
import {v4} from 'uuid'
import {s_chars} from "../_signals/s_chars";
import {useSignals} from "@preact/signals-react/runtime";
import {s_char} from "../_signals/s_char";
import {IChar} from "../_interfaces/IChar";
import {s_app_sl} from "../_signals/s_app";

type Props = {
    nsc: boolean;
};
export default function Chars({nsc}: Props) {
    useSignals()
    if (!s_app_sl.value) return null;

    const setCharFromChars = (char:IChar) => {
        s_char.value = char;
    }

    const charRow = (row: IChar) => {
        if (nsc !== row.nsc)return;

        return <Fragment key={v4()}>
            <TableRow key={v4()} onClick={() => setCharFromChars(row)}>
                <TableCell
                    style={{backgroundColor: row.schaden >= row.tot ? 'red' : row.schaden >= row.bew ? 'orange' : 'white'}}>
                    {row.name}
                </TableCell>
                <TableCell>{row.schaden}/{row.blutschaden}</TableCell>
                <TableCell>{row.wund}/{row.bew}/{row.tot}</TableCell>
                <TableCell>{row.wunden}/{row.blutwunden}</TableCell>
                <TableCell>{row.karma}</TableCell>
            </TableRow>
        </Fragment>
    }

    return <Paper style={{marginBottom:12,padding:6}}>
        <h3 style={{margin:4}}>{nsc ? 'NSC' : 'SC'}</h3>
        <TableContainer>
            <Table stickyHeader className={'playerTable'} style={{width: '100%'}}>
                <TableHead key={v4()}>
                    <TableRow key={v4()}>
                        <TableCell>name</TableCell>
                        <TableCell>schaden</TableCell>
                        <TableCell>schwellen</TableCell>
                        <TableCell>wunden</TableCell>
                        <TableCell>karma</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {Array.from(s_chars.value.entries()).map(([,char]) => charRow(char))}
                </TableBody>

            </Table>
        </TableContainer>
    </Paper>
}

